import icons from './icons'

const customIcon = (props) => {
    const { children } = props

    return (
        <svg viewBox="0 0 100 100" className="custom-icon" dangerouslySetInnerHTML={{ __html: icons[children] }} />
    )
}

export default customIcon